/**
 * Packaging OS — component helpers shared by catalog pages (Phase 1O-B).
 *
 * Non-component helpers live in catalogHelpers.ts.
 */

import { Button } from "../components/Button";
import type { UiStrings } from "../i18n/strings";

interface CatalogPaginationProps {
  page: number;
  pageSize: number;
  total: number;
  hasNext: boolean;
  onChange: (next: number) => void;
  t: UiStrings;
}

export function CatalogPagination({
  page,
  pageSize,
  total,
  hasNext,
  onChange,
  t,
}: CatalogPaginationProps): JSX.Element {
  const totalPages = pageSize > 0 ? Math.max(1, Math.ceil(total / pageSize)) : 1;
  return (
    <nav className="po-pagination" aria-label={t.catalogPaginationLabel}>
      <Button
        variant="secondary"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page <= 1}
      >
        {t.catalogPrevPage}
      </Button>
      <span className="po-request-id">
        {t.catalogPaginationLabel} <span className="dir-ltr-island">{page}</span>
        {" / "}
        <span className="dir-ltr-island">{totalPages}</span>
      </span>
      <Button
        variant="secondary"
        onClick={() => onChange(page + 1)}
        disabled={!hasNext}
      >
        {t.catalogNextPage}
      </Button>
    </nav>
  );
}
